import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Popover } from 'antd';
import { More } from '../../assets/icons';
import './PaymentItem.scss';
import { toastNotify } from '../../utils/toastNotify';
import { verifyMicroDeposit } from '../../services/LinkBankAccount/linkBankAccountApi';

const PaymentItem = (props) => {
  const { openDeleteModal, handleMakePrimary, logo, name, number, isPrimary, isExpired, type, id, isSingleAccount, bankVerificationStatus, setBankModalOpen, getLinkToken } = props;
  const className = isPrimary ? (isExpired ? 'expired' : 'primary') : isExpired ? 'expired' : '';
  const [popoverOpen, setPopoverOpen] = useState(false);
  const handleOpenChange = (newOpen) => {
    setPopoverOpen(newOpen);
  };
  const handleDelete = () => {
    if (isPrimary && !isSingleAccount) {
      const deleteWarning = 'To delete this, make another pPrimaryayment method primary';
      toastNotify('error', deleteWarning);
    } else {
      handleOpenChange(false);
      openDeleteModal();
    }
  };

  const verifiedMicroDepositonButton = async () => {
    const response = await verifyMicroDeposit(id);
    getLinkToken(response?.data?.linkToken)
    setBankModalOpen(true);
  }

  return (
    <div className={`payment-item ${className}`}>
      {logo}
      <div className='payment-item__details'>
        <span className='payment-item__name'>{name}</span>
        <span className='payment-item__number'>{`***${number}`}</span>
      </div>
      {!!isExpired && <span className='payment-item__status'>{type} expired</span>}
      <div className='badge-raper'>
        {bankVerificationStatus !== 'Verified' ? <span className='payment-item__primary cursor-pointer unverified' tabIndex={0} onClick={() => {
          bankVerificationStatus !== 'PlaidAutomatedUnverified' ? verifiedMicroDepositonButton() : toastNotify('info', 'Your bank is under verification process from Plaid. You will be notified when this bank is ready to use for transaction.');
        }}>Unverified</span> : ''}
        {!!isPrimary && !isExpired && <span className='payment-item__primary'>Primary</span>}
        <Popover
          placement='bottomRight'
          zIndex={999}
          trigger='click'
          open={popoverOpen}
          onOpenChange={handleOpenChange}
          content={
            <div className='action-list'>
              {!isPrimary && (
                <div
                  className={isPrimary ? 'action-list__item-disabled' : 'action-list__item'}
                  onClick={() => {
                    handleMakePrimary(id);
                    handleOpenChange(false);
                  }}
                >
                  {'Make primary payment method'}
                </div>
              )}
              <div
                // className={isPrimary && !isSingleAccount ? 'action-list__item-disabled' : 'action-list__item' }
                className='action-list__item'
                // onClick={() => {
                //   handleOpenChange(false);
                //   openDeleteModal()
                // }}
                onClick={() => handleDelete()}
              >
                {'Delete linked account'}
              </div>
            </div>
          }
        >
          <More className='cursor-pointer' />
        </Popover>
      </div>
    </div>
  );
};

PaymentItem.propTypes = {
  logo: PropTypes.element,
  type: PropTypes.string,
  isPrimary: PropTypes.bool,
  isExpired: PropTypes.bool,
  name: PropTypes.string,
  number: PropTypes.string,
};

export default PaymentItem;
